/**
 * Class selection as a grid of large buttons, grouped Adults / Kids.
 *
 * A dropdown would be fewer pixels but slower: 14 options means scanning a
 * list, and the front desk is picking under time pressure with a member
 * standing there. Everything visible at once, one tap.
 */
import { classesByAgeGroup } from '@shared/catalog';

export default function ClassPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (key: string) => void;
}) {
  return (
    <div className="space-y-4">
      {classesByAgeGroup().map((group) => (
        <div key={group.ageGroup}>
          <div className="mb-2 text-xs font-bold uppercase tracking-button text-white/35">
            {group.ageGroup}
          </div>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
            {group.classes.map((c) => {
              const selected = value === c.key;
              return (
                <button
                  key={c.key}
                  type="button"
                  onClick={() => onChange(c.key)}
                  aria-pressed={selected}
                  className={`min-h-touch rounded-btn border-2 px-3 py-2 text-sm font-bold
                              transition-all duration-brand ${
                                selected
                                  ? 'border-brand bg-brand text-paper'
                                  : 'border-edge bg-surface text-white/70 hover:border-brand hover:text-paper'
                              }`}
                >
                  {c.display}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
